import { select, call, put, takeLatest, cancelled } from 'typed-redux-saga';
import * as SearchActions from '../actions/search';
import * as selectors from '../selectors';
import { sendSearchResultsEvent } from './analytics';
import { searchArticles, SEARCH_PAGE_SIZE } from '../api/article';
import { getLanguageId } from '../utils/globals';
import { getNow } from './utils';
export function* requestSearch({ query, page, }) {
    const offset = (page - 1) * SEARCH_PAGE_SIZE;
    const fetchingStatus = yield* select(selectors.page.searchFetchingStatus, query, page);
    const shouldFetch = fetchingStatus === 'not-started';
    if (!shouldFetch)
        return;
    // const controller = new AbortController();
    try {
        yield* put(SearchActions.Actions.searchFetchStarted({ query, page }));
        const languageId = yield* call(getLanguageId);
        const data = yield* call(searchArticles, {
            term: query,
            languageId,
            offset,
            // controller,
        });
        const now = yield* call(getNow);
        yield* put(SearchActions.Actions.searchSuccess({
            ...data,
            searchedTerm: query,
            languageId,
            now,
        }));
        yield* call(sendSearchResultsEvent, query, page);
    }
    catch (error) {
        yield* put(SearchActions.Actions.searchFail());
    }
    finally {
        if (yield* cancelled()) {
            // controller.abort();
            yield* put(SearchActions.Actions.searchCancel());
        }
    }
}
// This watches for when we want to call the settings api and only allows the latest.
export function* watchSearchRequest() {
    yield* takeLatest(SearchActions.ActionTypes.SEARCH_REQUEST, function* (action) {
        yield* call(requestSearch, action.payload);
    });
}
//# sourceMappingURL=search.js.map